var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDownloadGreen = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25147 10.9302C9.25049 10.9143 9.25 10.8984 9.25 10.8824V4.76471C9.25 4.56189 9.32902 4.36739 9.46967 4.22398C9.61032 4.08057 9.80109 4 10 4C10.1989 4 10.3897 4.08057 10.5303 4.22398C10.671 4.36739 10.75 4.56189 10.75 4.76471V10.8824L10.75 10.8877L12.55 9.50589C12.7091 9.3842 12.9091 9.33195 13.106 9.36063C13.3029 9.38931 13.4806 9.49658 13.6 9.65883C13.7193 9.82108 13.7706 10.025 13.7424 10.2258C13.7143 10.4266 13.6091 10.6077 13.45 10.7294L10.45 13.0235C10.3201 13.1228 10.1622 13.1765 9.99996 13.1765C9.84447 13.1777 9.69246 13.1296 9.56496 13.0388L6.56496 10.8824C6.40327 10.7654 6.29357 10.5879 6.25984 10.3888C6.22611 10.1896 6.2711 9.98488 6.38496 9.81942C6.4418 9.73671 6.51415 9.6663 6.59782 9.61226C6.68149 9.55822 6.77483 9.52161 6.87245 9.50454C6.97007 9.48748 7.07004 9.4903 7.16659 9.51284C7.26314 9.53539 7.35435 9.57721 7.43496 9.63589L9.25147 10.9302Z",
    fill: "#17C680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15.2353C4 15.6576 4.33579 16 4.75 16H15.25C15.6642 16 16 15.6576 16 15.2353V13.7059C16 13.2835 15.6642 12.9412 15.25 12.9412C14.8358 12.9412 14.5 13.2835 14.5 13.7059V14.4706H5.5V13.7059C5.5 13.2835 5.16421 12.9412 4.75 12.9412C4.33579 12.9412 4 13.2835 4 13.7059V15.2353Z",
    fill: "#17C680"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownloadGreen);
export default ForwardRef;